import {CustomWindow} from '@utils/models/customwindow';
import {useBlockMedia} from "./video-block";

declare let window: CustomWindow;

export const useVideoBlockYouTube = () => {
  useBlockMedia().initializeConsentCheck(document.querySelectorAll(".video-block__content--youtube"));

  const initializeBlocks = () => {
    document.querySelectorAll(".video-block__content--youtube").forEach(element => {
      const blockElement = element as HTMLElement;

      // If this script is already initialized
      if (blockElement.dataset.initializedMedia === "true") {
        return;
      }

      blockElement.classList.remove("video-block__content--prevent-video");
      blockElement.classList.remove("video-block__content--show-video");

      // Set initialized attribute to prevent this script from running again
      blockElement.dataset.initializedMedia = "true";
    });
  };

  const initializeYoutube = () => window.KnowitOptimizelyFramework.YouTube?.initialize(initializeBlocks);
  if (window.Cookiebot.consent.marketing) {
    initializeYoutube();
  } else {
    window.addEventListener('CookiebotOnAccept', initializeYoutube);
  }
};

const initializeYouTubeMediaBlocks = () => {
  const initializeVideoAndPlay = (blockElement: Element) => {
    if (blockElement instanceof HTMLElement && !!window.KnowitOptimizelyFramework.YouTube && window.Cookiebot?.consent?.marketing) {
      if (!blockElement.querySelector("iframe")) {
        blockElement?.classList.remove("video-block__content--show-video");
        blockElement.classList.add("video-block__content--load-video");
        const {videoid, containerid} = blockElement.dataset;
        window.KnowitOptimizelyFramework.YouTube.createPlayer(videoid, containerid, onPlayerStateChange);
      } else {
        window.KnowitOptimizelyFramework.YouTube.playYouTubeVideo(blockElement);
      }
    }
  };

  const onPlayerStateChange = (event: { data: number }, ytPlayerId: string | undefined) => {
    const blockElement = document.querySelector(`#${ytPlayerId}`)?.closest(".video-block__content");
    if (event.data == window.YT.PlayerState.PAUSED) {
      blockElement?.classList.remove("video-block__content--show-video");
    } else if (event.data == window.YT.PlayerState.PLAYING) {
      blockElement?.classList.remove("video-block__content--load-video");
      blockElement?.classList.add("video-block__content--show-video");
    }
  };

  document.querySelectorAll(".video-block__content--youtube").forEach(element => {
    const blockElement = element as HTMLElement;

    // If this script is already initialized
    if (blockElement.dataset.initializedMediaBlockEvents === "true") {
      return;
    }

    blockElement.addEventListener("click", () => {
      initializeVideoAndPlay(blockElement);
    });

    blockElement.dataset.initializedMediaBlockEvents = "true";
  });
};

// This method is called from YouTube-api
window.onYouTubeIframeAPIReady = () => {
  initializeYouTubeMediaBlocks();
};